import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

Swiper.use([Autoplay]);

const hero = {
    init() {
        this.setSwiper();
    },
    setSwiper() {
        const swiper = new Swiper('.hero__swiper', {
            slidesPerView: 1,
            autoplay: true,
            loop: true
        })
    }
}

if (document.readyState === 'loading') { 
    document.addEventListener('DOMContentLoaded', () => hero.init()); 
  } else { 
    hero.init();
  }
  